// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, postRequestJson } from '@/libs/axios';

// 更新取证标题
export const _updateTitle = (params) => {
    return postRequest('/evidenceWebpage/updateTitle', params)
}

export const _getActivityList = () => {
    return getRequest('/activityRegisterActivition/list')
}

//新用户注册引导，首页弹窗推送需求-已登录
export const _getShowPopup = () => {
    return getRequest('/user/popup')
}
//新用户注册引导，首页弹窗推送需求-未登录
export const _getUnloginPopup = () => {
    return getRequest('/user/unloginPopup')
}
//领取会员接口
export const _getGiftVip = (params) => {
    return getRequest('/registerVipMemberApplication/giftVip', params)
};
//获取活动列表
export const _getActivityAll = (params) => {
    return getRequest('/activity/getByPage', params)
};

//兑换激活码   /bqjvip/activityRegisterActivation/activation/aliyun
export const _exchange = (params)=>{
    return getRequest('/activityRegisterActivation/activation/aliyun',params)
}

// 春节活动
export const _findIndexPageShowActivity = (params)=>{
    return getRequest('/registerVipConfig/findIndexPageShowActivity',params)
}
export const sendSmsCode = (params)=>{
    return postRequest('/user/sendSmsCode',params)
}
export const propertyRightLogon = (params)=>{
    return postRequest('/propertyRight/logon',params)
}
//426活动获取code
export const getFtsByCode = (params) =>{
    return getRequest('/commActivity/getByCode/426')
}
export const getftsConfig = (activityId)=>{
    return getRequest('/commActivityQa/getConfig/'+ activityId)
}





//获取题目所需的ID
export const getByCode = (code)=>{
    return getRequest('/commActivity/getByCode/'+code)

}

//答题
export const getAnswerListAll = (activityId)=>{
    return getRequest('/commActivityQa/getQuestionList/'+ activityId)
}

//题目验证
export const answerCheck = (activityId,params)=>{
    return postRequest('/commActivityQa/answerCheck/' + activityId,params)
}

//答案提交
export const answerSubmit = (params)=>{
    return postRequestJson('/commActivityQa/answerSubmit',JSON.stringify(params))
}

//获取用户活动参与信息
export const getUserParticipateInfo = (activityId,params)=>{
    return getRequest('/commActivityQa/getUserParticipateInfo/'+ activityId,params)
}

//获取用户活动参与二维码
export const getUserQrCode = (activityId,params)=>{
    return getRequest('/commActivityQa/getUserQrCode/'+ activityId,params)
}



